import ComputerPlayer from "./ComputerPlayer";
import Constants from "./../../constants/Constants";
import React from 'react';

export default class ComputerPlayerLeft extends ComputerPlayer {
    constructor(gameCtx, entityIndex, args) {
        super(gameCtx, entityIndex, args);

        this.setInitialCoords();
    }

    setInitialCoords = () => {
        let top = this.getTopPosForVerticalLayout();
        if (this.sHeight > this.sWidth) {
            this.firstCardCoords = [20, top];
        } else {
            this.firstCardCoords = [20, top + 30]
        }
    }

    calcRotateDeg = (cardObj = null, index, dinamicRotDeg = true) => {
        let cards = this.getCards();
        let deg = 0, currentDeg = 0;

        if (cardObj.ref.current != null) {
            currentDeg = cardObj.ref.current.getCurrentDeg();
        }

        let divider = dinamicRotDeg ? cards.length + 1 : Constants.MAX_CARD_FOR_EACH_PLAYER;
        deg = ((180 - Constants.FAN_ANGLE_MAX_RANGE) / 2) + ((Constants.FAN_ANGLE_MAX_RANGE / (divider + 1)) * (index + 1)) - currentDeg;

        return deg;
    }

    getCoordsForNewCard = (cardObj, dinamicRotDeg = true) => {
        let index = this.cards.length;
        return this.getCardCoordsByIndex(cardObj, index, dinamicRotDeg);
    }

    getCardCoordsByIndex(cardObj, index, dinamicRotDeg = true) {
        let rotDeg = this.calcRotateDeg(cardObj, index, dinamicRotDeg);
        let cardWidth = this.getCardsWidth();
        return [
            this.firstCardCoords[0],
            this.firstCardCoords[1] + ((cardWidth * index) / 2),
            rotDeg,
            this.cardSideShown,
            index + 1
        ];
    }

    addPlayingPlateOnLeftPlayer = (key) => {
        let playingPlateWidth = this.getCardsHeight() * 1.5
        let playingPlateHeight = (Constants.MAX_CARD_FOR_EACH_PLAYER) * this.getCardsWidth()
        let playingPlateTop = (this.sHeight - playingPlateHeight) / 2
        let playingPlateStyle = {
            width: `${playingPlateWidth}px`,
            height: `${playingPlateHeight}px`,
            borderRadius: '100%/50%',
            borderBottomLeftRadius: '0px',
            borderTopLeftRadius: '0px',
            border: '1px',
            position: 'absolute',
            top: `${playingPlateTop}px`,
            left: '0',
            backgroundColor: 'white',
        }

        const compPlayerTopPlayingPlate =
            <div key={key} className="playing-plate-parent">
                <div style={playingPlateStyle} className="playing-plate"></div>
            </div>;
        this.gameCtx.elementsHandler.addElement(key, compPlayerTopPlayingPlate);
    }

    addPlayingPlate = () => {
        this.addPlayingPlateOnLeftPlayer(Constants.ELEMENT_LEFT_PLAYER_PLAYING_PLATE)
    }

    removePlayingPlate = () => {
        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_LEFT_PLAYER_PLAYING_PLATE)
    }

    getTitlePlateStyle = () => {
        let left = this.getCardsHeight() - 7
        let bottom = this.sHeight - (this.firstCardCoords[1] + ((this.getCardsWidth() * (Constants.MAX_CARD_FOR_EACH_PLAYER + 4)) / 2)) - 5
        let titlePlateStyle = {
            width: `${Constants.TITLE_DIMENSION}vh`,
            height: `${Constants.TITLE_DIMENSION}vh`,
            position: 'absolute',
            left: `${left}px`,
            bottom: `${bottom}px`,
            zIndex: 3
        }
        return titlePlateStyle
    }

    getTitlePlateKey = () => {
        return Constants.ELEMENT_LEFT_PLAYER_TITLE_PLATE
    }

    addPlayerMarkup = () => {
        this.addPlayingPlateOnLeftPlayer(Constants.ELEMENT_LEFT_PLAYER_PLAYING_PLATE)
        this.addTitlePlateMarkup()
    }

    removePlayerMarkup = () => {
        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_LEFT_PLAYER_PLAYING_PLATE)
        this.removeTitlePlateMarkup()
    }
}